import { MOCK_MODE } from '@qcdoc/mock-runtime/adapter.ts';
import { PORTAL } from '../../app/portal.ts';
import { isEntraConfigured, isMsalConfigured } from '../../app/msalConfig.ts';

export type AuthMode = 'local' | 'entra' | 'mock-entra' | 'mock-msal' | 'mock-sso' | 'dev';

const requestedAuthMode = import.meta.env.VITE_AUTH_MODE as AuthMode | undefined;

// 'mock-sso' is the vendor portal's simulated Microsoft sign-in; VITE_AUTH_MODE=local restores its credential form.
export const AUTH_MODE: AuthMode = PORTAL === 'internal'
  ? requestedAuthMode === 'local' ? 'local' : isEntraConfigured ? 'entra' : isMsalConfigured ? 'mock-msal' : 'mock-entra'
  : PORTAL === 'vendor' ? requestedAuthMode === 'local' ? 'local' : 'mock-sso'
  : MOCK_MODE && import.meta.env.VITE_AUTH_MODE !== 'entra' ? 'local'
  : import.meta.env.VITE_DEV_AUTH === 'true' ? 'dev'
    : (requestedAuthMode ?? 'local');